import { forwardRef, memo, useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, ButtonBase, Menu, MenuItem, Box } from '@material-ui/core';
import _ from 'lodash';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { MoreIcon, AddIcon, DeleteIcon, ReNameIcon, ShowIcon, EyeHideIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { classNames } from '../../../../utils';
import { Delete, List, Rename } from './list';
import { functionFunc, groupDataFunc } from './constant';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.font.white,
    borderRadius: '0.9375rem',
    border: '0.0625rem solid #e4e7eb',
    padding: '2.438rem 0 1.125rem 1.563rem',
    marginBottom: '1.875rem',
    position: 'relative',
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    letterSpacing: '-0.05375rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    marginBottom: '2.5rem',
  },
  body: {
    display: 'flex',
    flexWrap: 'wrap',
    maxHeight: '41rem',
    overflowY: 'auto',
    '&>div': {
      marginRight: '1.688rem',
      marginBottom: '1.688rem',
    },
    '&>div:last-child': {
      marginRight: '0',
    },
  },
  Button: {
    // position: 'absolute',
    // top: '1.563rem',
    marginRight: '1.563rem',
    // display: 'flex',
  },
  iconBox: {
    width: '1.5rem',
    height: '1.5rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  icon: {
    fontSize: '1.125rem',
    color: '#c0c6cb',
  },
  addBtn: {
    width: '5.813rem',
    height: '3rem',
    borderRadius: '0.625rem',
    backgroundColor: theme.palette.primary.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
    marginRight: '1.563rem',
  },
  addIcon: {
    fontSize: '1rem',
    color: theme.palette.font.white,
    marginRight: '0.313rem',
  },
  menu: {
    boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    borderRadius: '0.16875rem',
    margin: '4rem 0 0 0rem',
    '& .MuiList-root': {
      '&>li:first-child': {
        border: '0',
      },
    },
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  menuitem: {
    padding: '1.25rem 1rem',
    height: '3.75rem',
    width: '13.313rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    borderTop: '0.0625rem solid #e4e7eb',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  deleteIcon: {
    fontSize: '1.25rem',
    color: '#525e6c',
  },
  renameIcon: {
    fontSize: '0.938rem',
    color: '#525e6c',
  },
  iconbox: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '1.063rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  showIcon: {
    fontSize: '1.25rem',
    color: '#525e6c',
  },
}));

const CardItem = SortableElement(({ triggerFunction, allData, list, updateGroup, groupIndex, smartComm }) => (
  <List
    // triggerFunction={(preIndex, nextIndex) => {
    //   return updateGroup(groupDataFunc.triggerFunction(allData, preIndex, nextIndex));
    // }}
    // accept={groupDataFunc.getGroupName(allData) + groupDataFunc.getGroupOrder(allData)}
    triggerFunction={triggerFunction}
    accept={`${groupDataFunc.getGroupId(allData)}`}
    index={groupIndex}
    title={functionFunc.getFunctionName(list)}
    listdate={list}
    setListdate={(functionData) => {
      updateGroup(groupDataFunc.setFunction(allData, groupIndex, functionData));
    }}
    delectListDate={() => {
      updateGroup(groupDataFunc.delectFunction(allData, groupIndex));
    }}
    id={`DutyAssign-List-ahz-${groupIndex}`}
    key={functionFunc.getId(list)}
    enableSmartComm={smartComm}
  />
));

const Card = SortableContainer(({ allData, updateGroup, triggerFunction, smartComm }) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.body, 'dndBody')}>
      {_.map(groupDataFunc.getAllFunction(allData), (list, index) => {
        return (
          <CardItem
            key={functionFunc.getId(list)}
            index={index}
            value={functionFunc.getId(list)}
            triggerFunction={triggerFunction}
            allData={allData}
            list={list}
            updateGroup={updateGroup}
            groupIndex={index}
            smartComm={smartComm}
          />
        );
      })}
    </div>
  );
});

const OnDuty = memo(
  forwardRef(function OnDuty({ allData, updateGroup, delectGroup, triggerFunction, smartComm }, ref) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [show, setShow] = useState(Boolean(groupDataFunc.getHide(allData)));
    const [renameDialogOpen, setRenameDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const handleRename = (groupName) => {
      updateGroup(groupDataFunc.setGroupName(allData, groupName));
    };

    const undpateHideNameHandle = (isHide) => {
      updateGroup(groupDataFunc.setHide(allData, Number(isHide)));
    };

    const delectGroupHandle = () => {
      setDeleteDialogOpen(true);
    };

    const addGroupHandle = () => {
      updateGroup(groupDataFunc.addFunction(allData));
    };

    const handleSortEnd = useCallback(
      (result) => {
        triggerFunction(result.oldIndex, result.newIndex);
      },
      [triggerFunction]
    );

    return (
      <>
        {deleteDialogOpen ? (
          <Delete
            open={deleteDialogOpen}
            id="DutyAssign-Delete-ahq"
            headerTitle={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DELETE')}
            setopen={setDeleteDialogOpen}
            handleDelete={delectGroup}
            content={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DELETE_BODY')}
          />
        ) : (
          ''
        )}
        {renameDialogOpen ? (
          <Rename
            headerTitle={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_RENAME')}
            open={renameDialogOpen}
            id="DutyAssign-Rename-ahr"
            setopen={setRenameDialogOpen}
            handleRename={handleRename}
            title={groupDataFunc.getGroupName(allData)}
          />
        ) : (
          ''
        )}
        <div className={classes.root} ref={ref}>
          <Box display="flex" justifyContent="space-between" flexDirection="row-reverse">
            <div className={classes.Button}>
              <ButtonBase className={classes.addBtn} onClick={addGroupHandle} id="DutyAssign-ButtonBase-ahs">
                <AddIcon className={classes.addIcon} />
                {i18n.t('DUTYASSIGN_ROSTER_ADD')}
              </ButtonBase>
              <IconButton
                className={classes.iconBox}
                onClick={(event) => {
                  setAnchorEl(event.currentTarget);
                }}
                id="DutyAssign-IconButton-aht"
              >
                <MoreIcon className={classes.icon} />
              </IconButton>
            </div>
            {groupDataFunc.getHide(allData) === 0 ? (
              <div className={classes.title}>{groupDataFunc.getGroupName(allData)}</div>
            ) : (
              ''
            )}
          </Box>
          <Menu
            className={classes.menu}
            anchorEl={anchorEl}
            open={open}
            id="DutyAssign-Menu-ahu"
            onClose={() => {
              setAnchorEl(false);
            }}
            keepMounted
          >
            <MenuItem
              className={classes.menuitem}
              onClick={() => {
                setRenameDialogOpen(true);
                setAnchorEl(false);
              }}
              id="DutyAssign-MenuItem-ahv"
            >
              <div className={classes.iconbox}>
                <ReNameIcon className={classes.renameIcon} />
              </div>
              {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_RENAME')}
            </MenuItem>
            {!show ? (
              <MenuItem
                className={classes.menuitem}
                onClick={() => {
                  setAnchorEl(false);
                  undpateHideNameHandle(true);
                  setShow(!show);
                }}
                id="DutyAssign-MenuItem-ahw"
              >
                <div className={classes.iconbox}>
                  <EyeHideIcon className={classes.showIcon} />
                </div>
                {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_HIDE')}
              </MenuItem>
            ) : (
              <MenuItem
                className={classes.menuitem}
                onClick={() => {
                  setAnchorEl(false);
                  undpateHideNameHandle(false);
                  setShow(!show);
                }}
                id="DutyAssign-MenuItem-ahx"
              >
                <div className={classes.iconbox}>
                  <ShowIcon className={classes.showIcon} />
                </div>
                {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DISPLAY')}
              </MenuItem>
            )}
            <MenuItem
              className={classes.menuitem}
              onClick={() => {
                setAnchorEl(false);
                delectGroupHandle();
              }}
              id="DutyAssign-MenuItem-ahy"
            >
              <div className={classes.iconbox}>
                <DeleteIcon className={classes.deleteIcon} />
              </div>
              {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DELETE')}
            </MenuItem>
          </Menu>
          <Card
            axis="xy"
            onSortEnd={handleSortEnd}
            allData={allData}
            updateGroup={updateGroup}
            triggerFunction={triggerFunction}
            smartComm={smartComm}
          />
        </div>
      </>
    );
  })
);
export default OnDuty;
